define('models/outbound/Contact',[
    'lib/knockout',
    'util/ObservableModel'
], function (ko, ObservableModel) {
    'use strict';

    var Contact = ObservableModel.extend({
        defaults: {
            data: null
        }
    }, function() {
        var self = this;

        self.hasData = ko.computed(function () {
            return self.data() !== null;
        });
    });

    return Contact;
});

